import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import { EnhancedTable } from "@vocollege/components";
import {
  GET_EDUCATIONS,
  DELETE_EDUCATION,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { EnhancedTableStatusCell } from "@vocollege/components";

export default function Educations() {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/content/educations/${id}`);
  };

  const getFilters = () => {
    return [
      {
        name: "status",
        label: I18n.get.form.labels.status,
        default: ["all"],
        values: [
          { label: I18n.get.actions.showAll, value: "all" },
          { label: I18n.get.status.published, value: "1" },
          { label: I18n.get.status.unpublished, value: "0" },
        ],
      },
    ];
  };

  return (
    <Layout>
      <EnhancedTable
        className="vo-global__top-bottom-space"
        enableSearch
        title={I18n.get.education.labels.educations}
        operations={{
          category: "educations",
          get: GET_EDUCATIONS,
          delete: DELETE_EDUCATION,
        }}
        labels={{
          deleted: I18n.get.education.messages.educationDeleted,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          { title: I18n.get.misc.code, field: "code" },
          { title: I18n.get.form.labels.title, field: "title" },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
          {
            title: I18n.get.form.labels.status,
            field: "status",
            width: 120,
            render: (data: any) => (
              <EnhancedTableStatusCell data={data.status} />
            ),
          },
        ]}
        addItem={editItem}
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
        filters={getFilters()}
      />
    </Layout>
  );
}
